module.exports = __webpack_public_path__ + "img/2d.165b2420.png";